<template>
  <div :class="$style.si">
    <svg
      viewBox="0 0 48 48"
      width="64"
      height="64"
      aria-hidden="true"
    >
      <circle
        cx="24"
        cy="24"
        r="9"
        fill="none"
        stroke="var(--track)"
        stroke-width="3"
      ></circle>
      <g :class="$style['si-spin-rot']">
        <circle
          :class="$style['si-spin-dash']"
          cx="24"
          cy="24"
          r="9"
          fill="none"
          stroke="var(--mark)"
          stroke-width="3"
          stroke-linecap="round"
          pathLength="1"
        ></circle>
      </g>
    </svg>
  </div>
</template>

<style
  lang="scss"
  module
>

.si {
  width: 64px; 
  height: 64px; 
  --mark: var(--action-primary); 
  --ring: var(--action-primary); 
  --track: var(--action-primary-softer);
  border-radius: 50%;
  display: grid;
  place-items: center;
  flex: none;
  position: relative;
  --si-dur: 3s;
}
.si svg {
  display: block;
  overflow: visible;
}
.si-trace {
  stroke-dasharray: 1;
  animation: si-trace var(--si-dur) infinite;
}
.si-trace2 {
  stroke-dasharray: 1;
  animation: si-trace2 var(--si-dur) infinite;
}
.si-ring {
  stroke-dasharray: 1;
  animation: si-ring var(--si-dur) infinite;
}
.si-dot {
  transform-box: fill-box;
  transform-origin: center;
  animation: si-dot var(--si-dur) infinite;
}
@keyframes si-trace {
  0% {
    stroke-dashoffset: 1;
    animation-timing-function: cubic-bezier(.6, 0, .2, 1);
  }
  30% {
    stroke-dashoffset: 0;
    animation-timing-function: linear;
  }
  70% {
    stroke-dashoffset: 0;
    animation-timing-function: cubic-bezier(.8, 0, .4, 1);
  }
  96%,
  100% {
    stroke-dashoffset: 1;
  }
}
@keyframes si-trace2 {
  0%,
  12% {
    stroke-dashoffset: 1;
    animation-timing-function: cubic-bezier(.6, 0, .2, 1);
  }
  40% {
    stroke-dashoffset: 0;
    animation-timing-function: linear;
  }
  70% {
    stroke-dashoffset: 0;
    animation-timing-function: cubic-bezier(.8, 0, .4, 1);
  }
  92%,
  100% {
    stroke-dashoffset: 1;
  }
}
@keyframes si-ring {
  0% {
    stroke-dashoffset: 1;
    animation-timing-function: cubic-bezier(.4, 0, .2, 1);
  }
  34% {
    stroke-dashoffset: 0;
    animation-timing-function: linear;
  }
  70% {
    stroke-dashoffset: 0;
    animation-timing-function: cubic-bezier(.8, 0, .4, 1);
  }
  96%,
  100% {
    stroke-dashoffset: 1;
  }
}
@keyframes si-dot {
  0%,
  34% {
    transform: scale(0);
    animation-timing-function: cubic-bezier(.34, 1.56, .64, 1);
  }
  46% {
    transform: scale(1);
  }
  84% {
    transform: scale(1);
    animation-timing-function: cubic-bezier(.6, 0, .4, 1);
  }
  93%,
  100% {
    transform: scale(0);
  }
}
.si-spin-rot {
  transform-box: fill-box;
  transform-origin: center;
  animation: si-rot 1.9s linear infinite;
}
.si-spin-dash {
  animation: si-dash 1.5s ease-in-out infinite;
}
@keyframes si-rot {
  to {
    transform: rotate(360deg);
  }
}
@keyframes si-dash {
  0% {
    stroke-dasharray: 0.04 0.96;
    stroke-dashoffset: 0;
  }
  50% {
    stroke-dasharray: 0.62 0.38;
    stroke-dashoffset: -0.16;
  }
  100% {
    stroke-dasharray: 0.04 0.96;
    stroke-dashoffset: -1;
  }
}
@media (prefers-reduced-motion: reduce) {
  .si-trace,
  .si-trace2,
  .si-ring {
    stroke-dasharray: none;
    animation: none;
  }
  .si-dot {
    animation: none;
    transform: none;
  }
  .si-spin-rot {
    animation-duration: 2.4s;
  }
  .si-spin-dash {
    stroke-dasharray: 0.55 0.45;
    animation: none;
  }
}
</style>
